import { RootState } from "@/store/store";
import { gridResourceDataSelector } from "@/store/resources-grid/selectors/resource-data/gridResourceDataSelector";

export const gridResourcesFilteredChildrenCountSelector = (
  state: RootState,
  masterGridId: string,
): number | undefined => {
  const data = gridResourceDataSelector(state, masterGridId);

  return data?.resources?.reduce((total, resource) => {
    const childResourcesCount =
      "child_resource" in resource
        ? resource?.child_resource?.filtered_resources_count
        : 0;

    return total + (childResourcesCount ?? 0);
  }, 0);
};
